<span #favoriteTooltipContainer class="d-inline-block product-favorite-icon-container" data-bs-toggle="tooltip"
  data-bs-html="true" [attr.data-bs-title]="favoriteTooltipHtmlContent" data-bs-sanitize="true" data-bs-delay="200"
  data-bs-placement="auto">
  <i class="bi" [ngClass]="isFavorite == true ? 'bi-heart-fill bi-heart-fill-red' : 'bi-heart'"
    [class.c-pointer]="isEnabled" (click)="isEnabled ? favoriteToggle() : null" clickable
    [attr.data-bs-title]="favoriteTooltipHtmlContent"></i>
</span>